import React from 'react';

/**
 * Direction badge for transaction tables.
 *
 *   <DirectionBadge direction="long" />   →  green  "LONG"
 *   <DirectionBadge direction="short" />  →  orange "SHORT"
 *
 * Pair with <ExitReasonPill reason={trade.exit_reason} /> when the row came
 * from a rec_shorts file (SL5% / TP10% / TP20% etc).
 */
export function DirectionBadge({ direction, className = '' }) {
  const isShort = direction === 'short';
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold border ${
        isShort
          ? 'bg-orange-900/40 text-orange-300 border-orange-700/50'
          : 'bg-emerald-900/40 text-emerald-300 border-emerald-700/50'
      } ${className}`}
      title={isShort ? 'Short trade — sell first, cover later' : 'Long trade — buy first, sell later'}
    >
      <span aria-hidden="true">{isShort ? '↘' : '↗'}</span>
      {isShort ? 'SHORT' : 'LONG'}
    </span>
  );
}

/**
 * Small grey pill for rec_shorts exit reasons (SL5%, TP10%, TP20%, "SELL signal", etc.).
 * Renders nothing when reason is empty.
 */
export function ExitReasonPill({ reason, className = '' }) {
  if (!reason) return null;
  return (
    <span
      className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-medium uppercase tracking-wide bg-dark-700 text-dark-300 border border-dark-600 ${className}`}
      title="Exit reason from the rec_shorts model"
    >
      {reason}
    </span>
  );
}

export default DirectionBadge;
